import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { HashLink as NavLink } from 'react-router-hash-link';
import Contact from '@material-ui/icons/ContactMail';
import people from '../assets/svg/sidebar SVGs/Icon ionic-ios-people.svg';
import PersonAdd from '@material-ui/icons/PersonAdd';
import Home from '@material-ui/icons/Home';
import ExitToApp from '@material-ui/icons/ExitToApp';
import OurServices from '@material-ui/icons/Help';
import Cross from '@material-ui/icons/Close';
import helpPeople from '../assets/svg/sidebar SVGs/people-carry-solid.svg';
import person from '../assets/icons/Sed-01-512.png';
import { useDispatch, useSelector } from 'react-redux';
import { signOutUser } from '../redux/actions/auth';
import { useHistory, useLocation } from 'react-router-dom';

function Sidebar({ toggle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const profile = useSelector((state) => state.userProfileReducer.userProfile);

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );

  const handleSignOut = () => {
    dispatch(signOutUser(history));
  };

  return (
    <div className='overlay overflow-hidden z-50 min-sidebar-height fixed'>
      <div className='bg-white w-70-percent h-screen min-sidebar-height'>
        {isAuthenticated ? (
          <div className='sm:p-10 p-3 pt-8 sm:h-40 h-32 relative '>
            <Cross
              alt='cross'
              onClick={toggle}
              style={{ color: 'gray' }}
              fontSize='small'
              className='absolute top-0 right-0 sm:m-6 m-4 w-4'
            />

            <div className='flex items-center justify-around'>
              <RouterLink to='/profile'>
                <img
                  src={profile.imgUrl || person}
                  alt='person'
                  className='sm:w-26 w-20 rounded-full'
                  onClick={toggle}
                />
              </RouterLink>
              <div
                className='text-right  sm:ml-3 ml-1 font-normal 
              text-gray-600 text-base sm:text-xl  '
              >
                <span className='ml-1'>{profile.fullName} </span>
                <RouterLink
                  to='/profile'
                  className='flex items-center justify-end '
                  onClick={toggle}
                >
                  <PersonAdd alt='add' className='sm:m-2 mr-1' />
                  <span className='text-sm md:text-lg'> تعديل الحساب</span>
                </RouterLink>
              </div>
            </div>
          </div>
        ) : (
            <div className="sm:p-10 p-3 pt-8 relative bg-n-blue">
              <Cross
                alt="cross"
                onClick={toggle}
                style={{ color: "white" }}
                className="absolute top-0 right-0 sm:m-6 m-4 w-4"
              />
            </div>
          )}
        <div className="bg-n-blue w-full h-full text-white py-4  font-normal text-s ">
          <RouterLink
            to="/"
            className={`flex items-center justify-between py-4 pr-8 md:pr-24 pl-4 md:pl-12 ${location.pathname === "/" && location.hash === ""
              ? "shadow-xl bg-dark-sidebare"
              : ""
              }`}
            onClick={toggle}
          >
            <Home alt='home' className=' ml-3' style={{ fontSize: 26 }} />
            <span>الصفحة الرئيسية</span>
          </RouterLink>
          <RouterLink
            to='/Dashboard'
            className={`flex items-center justify-between py-4 pr-8 md:pr-24 pl-4 md:pl-12 ${location.pathname === '/Dashboard'
                ? 'shadow-xl bg-dark-sidebare'
                : ''
              }`}
            onClick={toggle}
          >
            <OurServices alt='question' className=' ml-3' />
            <span>خدماتنا</span>
          </RouterLink>
          <RouterLink
            to='/contact-us'
            className={`flex items-center justify-between py-4 pr-8 md:pr-24 pl-4 md:pl-12 ${location.pathname === '/contact-us'
                ? 'shadow-xl bg-dark-sidebare'
                : ''
              }`}
            onClick={toggle}
          >
            <Contact alt='Contact' className='ml-4' style={{ fontSize: 20 }} />
            <span>تواصل معنا</span>
          </RouterLink>
          <RouterLink
            to='/ask-for-help'
            className={`flex items-center justify-between py-4 pr-8 md:pr-24 pl-4 md:pl-12 ${location.pathname === '/ask-for-help'
                ? 'shadow-xl bg-dark-sidebare'
                : ''
              }`}
            onClick={toggle}
          >
            <img src={helpPeople} alt='phone' className='ml-3 w-6' />
            <span>اطلب المساعدة</span>
          </RouterLink>

          <NavLink
            // activeClass="active"
            to='/about-us'
            spy='true'
            smooth={true}
            offset={0}
            duration={500}
            className={`flex items-center justify-between py-4 pr-8 md:pr-24 pl-4 md:pl-12 ${location.pathname === '/' && location.hash === '#about'
                ? 'shadow-xl bg-dark-sidebare'
                : ''
              }`}
            onClick={toggle}
          >
            <img src={people} alt='info' className='ml-3  ' />
            <span>من نحن؟</span>
          </NavLink>
          {isAuthenticated ? (
            <div
              className='flex items-center pr-8 md:pr-24 py-4 mb-16 pl-4 md:pl-12 justify-between '
              onClick={handleSignOut}
            >
              <ExitToApp
                id='signOut'
                alt='logout'
                className='ml-3'
                style={{ fontSize: 26 }}
              />
              <span>تسجيل خروج</span>
            </div>
          ) : null}
        </div>
      </div>
      <div
        className='w-27-percent h-screen  absolute top-0 right-0'
        onClick={toggle}
      ></div>
    </div>
  );
}
export default Sidebar;
